import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, ThemeProvider } from './providers';
import { setGlobalQueryClient } from './services/auth/userService';
import HomePage from './pages/HomePage';
import CalendarPage from './pages/CalendarPage';
import BookmarksPage from './pages/BookmarksPage';
import BookmarkInstallPage from './pages/BookmarkInstallPage';
import SettingsPage from './pages/SettingsPage';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 1000,
      staleTime: 5 * 60 * 1000, // 5分钟
      gcTime: 10 * 60 * 1000, // 10分钟（原 cacheTime）
      networkMode: 'online',
      // 添加超时保护（通过 AbortController）
    },
    mutations: {
      retry: 0, // Mutation 默认不重试
    },
  },
});

function App() {
  // 设置全局 QueryClient，供所有服务使用
  useEffect(() => {
    setGlobalQueryClient(queryClient);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/bookmarks" element={<BookmarksPage />} />
              <Route path="/bookmarks/install" element={<BookmarkInstallPage />} />
              <Route path="/bookmarks/:folderId" element={<BookmarksPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
